<template>
	<div class="table-area">
		<div class="tabel-area-content">
			<div class="operation-bar" style="display: flex">
				<search-form ref="searchFormRef" />
				<el-button style="margin-left: auto" v-click-blur class="btn" type="primary" @click="handleQueryClick">
					查 询
				</el-button>
				<el-button v-show="!editing" v-click-blur class="btn" type="default" @click="handleResetQueryClick">
					重 置
				</el-button>
			</div>
		</div>
		<div class="table-wrapper" v-loading="loading">
			<gc-table
				ref="deviceTableRef"
				border
				showPage
				need-type="selection"
				:total="total"
				:columns="columns"
				:table-data="tableData"
				:current-page.sync="currentPage"
				:page-size="pageSize"
				@current-page-change="pageChange"
				@size-change="handleSizeChange"
				@selectChange="handleSelectChange"
			></gc-table>
		</div>
		<div class="form-wrapper">
			<el-form inline :model="formData">
				<el-form-item v-if="showComparisonName" :label="comparison.comparisonName" required>
					<el-input-number v-model="formData.duration" :min="1" step-strictly :step="1"></el-input-number>
					<span class="label-unit">{{ comparison.comparisonUnit }}</span>
				</el-form-item>
				<el-form-item label="报警等级">
					<el-select v-model="formData.level" placeholder="请选择">
						<el-option
							v-for="option in alarmLevelOptions"
							:key="option.value"
							:label="option.label"
							:value="option.value"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="推送方式">
					<el-select v-model="formData.pushCreateBIds" placeholder="请选择" multiple>
						<el-option
							v-for="option in eventList"
							:key="option.value"
							:label="option.label"
							:value="option.value"
						/>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import SearchForm from '@/pages/alarm-water/dedicated-alarm/components/search-form/index.vue'
import { apiGetLedgerList } from '@/apis/waterAlarmConfig.api'
import { columns } from './config'

export default {
	name: 'DialogTable',
	props: {
		waterRegionCode: {
			type: String,
			default: '',
		},
		visible: {
			type: Boolean,
			default: false,
		},
		eventId: {
			type: Number,
			default: undefined,
		},
		showComparisonName: {
			type: Boolean,
			default: false,
		},
	},
	inject: ['getComparison'],
	components: {
		SearchForm,
	},
	data() {
		return {
			loading: false,
			columns,
			total: 1,
			tableData: [],
			currentPage: 1,
			pageSize: 20,
			alarmLevelOptions: [],
			formData: {
				duration: undefined,
				level: '',
				pushCreateBIds: [],
			},
			searchParams: {},
			selectedRows: [],
			eventList: [
				{ label: '员工微信推送', value: '1' },
				{ label: '员工短信推送', value: '2' },
				{ label: '页面推送', value: '3' },
				{ label: '声音告警', value: '4' },
			],
		}
	},
	computed: {
		tenantType() {
			// 0-燃气租户 1-水务租户
			return this.$store.getters.userInfo.tenantType || '0'
		},
		comparison() {
			// DedicatedAlarm组件provide
			return this.getComparison()
		},
	},

	mounted() {
		this.alarmLevelOptions = this.extractList(this.$store.getters.dataList.alarmLevel)
		this.formData = {
			duration: 1,
			level: this.alarmLevelOptions[0].value,
			pushCreateBIds: [],
		}
	},
	watch: {
		waterRegionCode: {
			handler(val) {
				this.getTableData({ waterRegionCode: val })
			},
		},
		visible: {
			handler(val) {
				if (val) {
					this.resetField()
				}
			},
		},
	},
	methods: {
		handleParamsChange(params) {
			this.searchParams = params
		},
		handleSelectChange(selection) {
			const tableDataIds = this.tableData.map(item => item.deviceId)
			const stillSelectedRows = this.selectedRows.filter(item => !tableDataIds.includes(item.deviceId))
			this.selectedRows = [...stillSelectedRows, ...selection]
		},
		handleQueryClick() {
			this.currentPage = 1
			this.getTableData({ current: 1 })
		},
		handleResetQueryClick() {
			this.$refs.searchFormRef.resetSearchParams()
			this.handleQueryClick()
		},
		pageChange(current) {
			this.currentPage = current
			this.getTableData({ current })
		},
		handleSizeChange(size) {
			this.pageSize = size
			this.currentPage = 1
			this.getTableData({ current: 1 })
		},
		generateParams(params) {
			return {
				deviceStatus: 1,
				eventId: this.eventId,
				size: this.pageSize,
				current: this.currentPage,
				...this.searchParams,
				waterRegionCode: this.waterRegionCode,
				tenantType: this.tenantType,
				...params,
			}
		},
		refreshTable() {
			this.getTableData({ current: this.currentPage })
		},
		async getTableData(data) {
			this.searchParams = this.$refs.searchFormRef.getSearchParams()
			const caliber = Number(this.searchParams.caliber)
			const caliberNum = Number(caliber)
			if (
				!!caliber &&
				(isNaN(caliberNum) || Math.floor(caliberNum) !== caliberNum || caliberNum < 1 || caliberNum > 2000)
			) {
				this.$message.warning('口径只能为1-2000之间的整数')
				return
			}
			const params = this.generateParams(data)
			const res = await this.getLedgerList(params)
			this.tableData = res.records
			this.total = res.total
			this.$refs.deviceTableRef.toggleRowSelection(this.selectedRows, 'deviceId')
		},
		getLedgerList(params) {
			this.loading = true
			return apiGetLedgerList(params)
				.then(res => res)
				.catch(() => ({ records: [], total: 0 }))
				.finally(() => {
					this.loading = false
				})
		},
		getData() {
			return {
				...this.formData,
				selectedRows: this.selectedRows,
			}
		},
		extractList(list) {
			return list.map(item => ({
				label: item.name,
				value: item.defaultValue,
			}))
		},
		resetField() {
			this.selectedRows = []
			this.pageSize = 20
			this.currentPage = 1
			this.formData = {
				duration: 1,
				level: this.alarmLevelOptions[0].value,
				pushCreateBIds: [],
			}
			this.refreshTable()
		},
	},
}
</script>

<style scoped lang="scss">
.gc-table {
	height: 400px;
}

.table-area {
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: auto;
}

.table-wrapper {
	flex: 1;
	margin-top: 12px;
}

.form-wrapper {
	border-top: 1px solid #e6e6e6;
	padding-top: 10px;
	padding-left: 10px;
}
.label-unit {
	margin-left: 4px;
}
</style>
